import React, { useState, useEffect } from 'react'
import { Ilist } from 'servers/searchSchool/interface'
import LoadMore from 'components/LoadMore'
import useStore from 'store'
import emptyImg from 'static/images/empty.svg'
import Loading from 'components/Loading'
import { getQueryString } from 'utils/util'
import s from './index.module.less'

interface IProps {
  schoolList?: Ilist[]
  total: number
  loading: boolean
}

const SigleSchool: React.FC<IProps> = ({ schoolList, total, loading }) => {
  const { state, dispatch } = useStore()
  const [nowSchoolist, setNowSchoolist] = useState<Ilist[]>([])
  const [mounted, setMounted] = useState(false)
  const { filterParamsData } = state

  const fetchMoreData = () => {
    return new Promise((resolve: any) => {
      setTimeout(() => {
        dispatch({
          type: 'updateFilterParamsData',
          payload: { page: (filterParamsData?.page || 1) + 1 }
        })
        resolve()
      }, 300)
    })
  }

  useEffect(() => setMounted(true), [])

  useEffect(() => {
    if (schoolList) {
      if (filterParamsData?.page !== 1) {
        setNowSchoolist([...nowSchoolist, ...schoolList])
      } else {
        setNowSchoolist(schoolList)
      }
    }
  }, [schoolList])

  return (
    <>
      {!nowSchoolist?.length && loading ? (
        <Loading />
      ) : nowSchoolist.length ? (
        <ul className={s.SigleSchool} id="FillSchool">
          {nowSchoolist.map((v) => (
            <li className={s.schoolContent} key={v.schoolName}>
              <div className={s.SchoolTitle}>
                <div className={s.imgContent}>
                  <img src={v.schoolBadge} alt="logo" />
                </div>
                <div className={s.schoolContentBox}>
                  {v.schoolId ? (
                    <a
                      className={s.schoolName}
                      href={`/searchSchool/${v.schoolId}/base${
                        getQueryString('port') ? `?port=${getQueryString('port')}` : ''
                      }`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <p className={s.schoolName}>{v?.schoolName}</p>
                    </a>
                  ) : (
                    <p className={s.schoolName}>{v?.schoolName}</p>
                  )}
                  <p className={s.des}>
                    {v.belongProvince}｜{v.schoolTypeAttribute}｜
                    {v?.educationLevel === 'UNDERGRADUATE' ? '本科' : '专科'}｜{v.belongDepartment}
                    ｜{v.schoolTypes[0]}
                  </p>
                  <p className={s.code}>
                    {v.schoolTags.map((m) => (
                      <span className={s.tags} key={`${v.schoolName}${m}`}>
                        {m}
                      </span>
                    ))}
                  </p>
                </div>
                {v.grade && (
                  <div className={s.grade}>
                    <p className={s.num}>{v.grade}</p>
                    <p className={s.text}>软科评级</p>
                  </div>
                )}
                <button
                  type="button"
                  className={s.detail}
                  onClick={() =>
                    window.open(
                      `/searchSchool/${v.schoolId}/base?type=schoolProfile${
                        getQueryString('port') ? `&port=${getQueryString('port')}` : ''
                      }`
                    )
                  }
                >
                  院校详情
                </button>
              </div>
            </li>
          ))}
          {mounted && !!nowSchoolist.length && (
            <LoadMore
              // @ts-ignore
              loading={loading}
              hasMore={nowSchoolist.length < total}
              fetchMore={fetchMoreData}
            />
          )}
        </ul>
      ) : (
        <div className={s.Fillnone}>
          <img src={emptyImg} alt="" />
          <p>暂未找到符合条件的院校</p>
        </div>
      )}
    </>
  )
}

SigleSchool.defaultProps = {
  schoolList: undefined
}

export default SigleSchool
